/** @param {number} interval_seconds */
export const sleep = async (interval_seconds) =>
  new Promise((resolve) => setTimeout(resolve, interval_seconds * 1000))
